export { RenderCurrentStaticPage } from './render-current-static-page';
